import { render, staticRenderFns } from "./VotingsMandateName.vue?vue&type=template&id=6ac0846f&"
import script from "./VotingsMandateName.vue?vue&type=script&lang=js&"
export * from "./VotingsMandateName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports